import React from 'react';

import { Modal, message } from 'antd';

import fetch from './fetch';
import utils from './../utils';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('folder/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('folder/tree', keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(utils.tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('folder/insert', data)
    .then(response => {
        if(response.code === 200) {
            message.success('数据添加成功！');
        }
        
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('folder/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            message.success('数据更新成功！');
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('folder/remove/', ids)
    .then(response => {
        return {
            message: response.message
        };
    }).catch(error => {
        // console.log('error');
    });
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove
}